import { client } from "../common/client";
import type {
  CompetitorMatchedProductsRequest,
  CompetitorMatchedProductsResponse,
} from "./utils/types";

class CompetitorAPIClient {
  public async getCompetitorMatchedProducts(
    params?: CompetitorMatchedProductsRequest,
  ): Promise<CompetitorMatchedProductsResponse> {
    return await client
      .get("/competitor/matchedProducts", { params })
      .then((res) => res.json());
  }
}

export const competitorAPIClient = new CompetitorAPIClient();
